import { render, staticRenderFns } from "./VwCreate.vue?vue&type=template&id=502d75d6&lang=pug&"
import script from "./VwCreate.vue?vue&type=script&lang=ts&"
export * from "./VwCreate.vue?vue&type=script&lang=ts&"
import style0 from "./VwCreate.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VwCreate.vue"
export default component.exports